/* ========================================
   Collection Product Card Swatches
   Handles:
   - Variant selection
   - Hover image swap
   - Variant name update
   - Quick-add modal and links update
   - Works with dynamically added cards (infinite scroll)
======================================== */

document.addEventListener('DOMContentLoaded', () => {

  // -------------------------------
  // Helper: swap image with fade
  // -------------------------------
  function swapImage(img, url, fade = true) {
    if (!img || !url) return;

    const srcset = [
      `${url}?width=165 165w`,
      `${url}?width=360 360w`,
      `${url}?width=533 533w`,
      `${url}?width=720 720w`,
      `${url}?width=940 940w`,
      `${url}?width=1066 1066w`
    ].join(',');

    if (fade) {
      img.style.opacity = 0;
      img.onload = () => { img.style.opacity = 1; };
    } else {
      img.style.transition = 'none';
    }

    img.src = url;
    img.srcset = srcset;
    img.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';

    if (!fade) {
      setTimeout(() => { img.style.transition = 'opacity 0.3s ease'; }, 10);
    }
  }

  // -------------------------------
  // Helper: update variant name
  // -------------------------------
  function updateVariantName(card, name) {
    const nameContainer = card.querySelector('.collection-product-card__variant-name');
    if (nameContainer) nameContainer.textContent = name || '';
  }

  // -------------------------------
  // Initialize a single card
  // -------------------------------
  function initCardSwatches(card) {
    if (!card || card.dataset.swatchInit) return;
    card.dataset.swatchInit = 'true';

    const inputs = card.querySelectorAll('input[type="radio"][data-variant-id]');
    const labels = card.querySelectorAll('.collection-product-card__swatch label');
    const img = card.querySelector('.card__media .media img');

    if (!img || inputs.length === 0) return;

    // -------------------------------
    // Set first variant as default
    // -------------------------------
    const firstInput = inputs[0];
    firstInput.checked = true;
    swapImage(img, firstInput.dataset.imageUrl);
    updateVariantName(card, firstInput.dataset.variantName);

    const links = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
    links.forEach(link => {
      link.href = link.href.split('?')[0] + `?variant=${firstInput.dataset.variantId}`;
    });

    // -------------------------------
    // Hover effect
    // -------------------------------
    labels.forEach(label => {
      label.addEventListener('mouseenter', () => {
        const input = label.previousElementSibling;
        if (input && input.dataset.imageUrl) {
          swapImage(img, input.dataset.imageUrl, false);
          updateVariantName(card, input.dataset.variantName);
        }
      });

      label.addEventListener('mouseleave', () => {
        const selected = card.querySelector('input[type="radio"][data-variant-id]:checked');
        if (selected) {
          swapImage(img, selected.dataset.imageUrl, false);
          updateVariantName(card, selected.dataset.variantName);
        }
      });
    });

    // -------------------------------
    // Variant change
    // -------------------------------
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        const variantId = input.dataset.variantId;

        swapImage(img, input.dataset.imageUrl);
        updateVariantName(card, input.dataset.variantName);

        // Update quick-add modal button
        const modalOpener = card.querySelector('[data-modal]');
        if (modalOpener) modalOpener.dataset.variantId = variantId;

        // Update add-to-cart button
        const addButton = card.querySelector('button[data-variant-id]');
        if (addButton) addButton.dataset.variantId = variantId;

        // Update all links
        links.forEach(link => {
          link.href = link.href.split('?')[0] + `?variant=${variantId}`;
        });
      });
    });
  }

  // -------------------------------
  // Initialize all existing cards
  // -------------------------------
  document.querySelectorAll('.card-product-custom-div').forEach(card => {
    initCardSwatches(card);
  });

  // -------------------------------
  // Observe for new cards (infinite scroll)
  // -------------------------------
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('.card-product-custom-div')) {
          initCardSwatches(node);
        } else if (node.nodeType === 1) {
          node.querySelectorAll('.card-product-custom-div').forEach(card => initCardSwatches(card));
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
